import { render, staticRenderFns } from "./InviteFriendsHeader.vue?vue&type=template&id=0f93a7d6&"
import script from "./InviteFriendsHeader.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports